type Fn<TArgs extends unknown[], TResult> = (...args: TArgs) => TResult;

export function memoize<TArgs extends unknown[], TResult> (fn: Fn<TArgs, TResult>): Fn<TArgs, TResult> {
  const cache: Record<string, TResult> = {}
  const _fn = (...args: TArgs) => {
    const key = JSON.stringify(args)
    if (!cache[key]) cache[key] = fn(...args)
    return cache[key]
  }
  _fn.cache = cache
  return _fn
}
